export default "__VITE_ASSET__Cl9eG9EM__"